import { useQuery } from '@apollo/client'

import { GET_COUNTRIES_V2 } from '../../data/gql/questionnaire/queries/getCountries'
import { LoggerErrorType } from '../../data/logger'
import { captureApolloError } from '../../utils/HelperFunctions'
import { PanelSupplier } from '../../utils/audienceHelper'

export const useAudienceCountries = (panelSupplierCode?: string) => {
  const { data, loading, error } = useQuery(GET_COUNTRIES_V2, {
    variables: { panelSupplierCode: panelSupplierCode || PanelSupplier.CINT },
    context: { clientName: 'questionnaire' },
    onError: (error) => {
      captureApolloError(LoggerErrorType.ApolloQuery, 'countries', error)
    }
  })

  return { data: data?.getCountriesV2, loading, error }
}
